<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { GiftSuggestion } from '@consumer/types/serializers'
import { FreeMode, Keyboard, Mousewheel } from 'swiper/modules'
import GiftSuggestionsItem from '@consumer/modules/shared/GiftSuggestionsItem.vue'

import 'swiper/css'

withDefaults(defineProps<{
  giftSuggestions: GiftSuggestion[]
  gaTrackName?: string
}>(), {  })
</script>

<template>
  <div>
    <Swiper
      :modules="[FreeMode, Keyboard, Mousewheel]"
      :slidesPerView="'auto'"
      :mousewheel="{
        forceToAxis: true
      }"
      :keyboard="{
        enabled: true
      }"
      :spaceBetween="12"
      class="gift-suggestions-swiper"
    >
      <SwiperSlide
        v-for="giftSuggestion, i in giftSuggestions"
        :key="i"
        class="gift-suggestions-swiper-slide"
      >
        <GiftSuggestionsItem :giftSuggestion="giftSuggestion" :gaTrackName="gaTrackName"/>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style lang="scss" scoped>
.gift-suggestions-swiper-slide {
  height: auto;
  margin-bottom: 4px;
  width: auto;
}
</style>
